import * as categories from '../categories';
import { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, PERFORMANCE, SOCIAL } from '../constants';

const dict = {
	1: STRICTLY_NECESSARY,
	2: PERFORMANCE,
	3: FUNCTIONAL,
	4: TARGETING,
	5: SOCIAL,
	8: SOCIAL,
	C0001: STRICTLY_NECESSARY,
	C0002: PERFORMANCE,
	C0003: FUNCTIONAL,
	C0004: TARGETING,
	C0005: SOCIAL,
	C0007: PERFORMANCE,
	C0008: SOCIAL
};

export const set = (ids) => {
	const newCats = (Array.isArray(ids) ? ids : ids.split(',')).map(id => dict[id]).filter(a => !!a);
	categories.set(newCats);
};
